import gql from 'graphql-tag';

export const UpdateAccidentIssue = gql`
  mutation UpdateAccidentIssueBulk($input: UpdateAccidentIssueBulkInput!) {
    updateAccidentIssueBulk(input: $input) {
      response {
        updated
        error {
          code
          message
          debug
        }
      }
    }
  }
`;
